import { DemandInformationMessage } from '../../../../types/DemandInformationMessage';
import { Iso8601DateTimeString } from '../../../../types/Iso8601DateTimeString';
import { ProductContext } from '../../../../types/ProductContext';
import { SortingKey } from '../../../demand/components/SortingKey';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const getDemandInformation = async (
    sortingKey: SortingKey,
    groupId?: string
): Promise<DemandInformationMessage> => {
    const response = await authorizedAxiosInstance.get<DemandInformationMessage>('/v2/demand-information', {
        params: {
            sortingKey,
            context: ProductContext.LUBES,
            groupId: groupId || undefined,
        },
    });

    return response.data;
};

interface ShareDemandRequestMessage {
    receiverEmailAddresses: string[];
    copyToSelf: boolean;
    fromDate: Iso8601DateTimeString;
    toDate: Iso8601DateTimeString;
}

interface ShareDemandInformationConfig {
    vesselId: string;
    requestMessage: ShareDemandRequestMessage;
}

export const shareDemandInformation = async ({
    vesselId,
    requestMessage,
}: ShareDemandInformationConfig): Promise<void> => {
    await authorizedAxiosInstance.post(`/v2/demand-information/${vesselId}/share`, requestMessage);
};
